:host {
  --exposure: 50%;
  --divider-width: 2px;

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  ::slotted(*) {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ::slotted([slot="image-after"]) {
    clip-path: polygon(
      calc(var(--exposure) + (var(--divider-width) / 2)) 0,
      100% 0,
      100% 100%,
      calc(var(--exposure) + (var(--divider-width) / 2)) 100%
    );
  }
}

.stzh-imagecomparison {
  display: flex;
  flex-direction: column;
  user-select: none;

  &__control {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
  }

  &__slider-line {
    position: absolute;
    left: var(--exposure);
    height: 100%;
    width: var(--divider-width);
    background-color: $colorWhite;
    transform: translateX(-50%);
    transition: background-color $baseTransitionAnimationSpeed;
  }

  &__slider-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    left: var(--exposure);
    overflow: hidden;
    width: calc(2 * #{iconSize()} + var(--divider-width));
    height: #{iconSize()};
    transform: translate(-50%, -50%);
    color: $colorPrimary70;
    background-color: $colorWhite;
    transition-property: color, background-color;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__hint-wrapper {
    pointer-events: none;
    opacity: 0;
    transition: opacity $baseTransitionAnimationSpeed;
  }

  &__hint-left,
  &__hint-right {
    @include font('heavy');
    @include fontSize('micro');
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    height: 24px;
    padding: 0 space('xsmall');
    background: $colorBlack50op;
    color: $colorWhite;
  }

  &__hint-left {
    left: 0;
  }

  &__hint-right {
    right: 0;
  }

  &__label:hover &__slider-line {
    background-color: $colorPrimary70;
 }

  &__label:hover &__slider-icon-wrapper {
    background-color: $colorSecondary30;
  }

  &__label:hover + &__hint-wrapper {
    opacity: 1;
  }
}
